<template>
  <div class="w-full">
    <h1 class="section-title">
      Spieltag erstellen
    </h1>

    <form class="w-full max-w-lg">
      <div class="flex flex-wrap -mx-3 mb-6">
        <div class="w-full  px-3 mb-8">
          <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
            Event-Name
          </label>
          <div class="ctl-edit-container">
            <input
              v-model="title"
              class="ctl-edit w-128"
              type="text"
              placeholder="Freundschaftsspiel, Staffeltag..."
            >
          </div>
        </div>
        <div class="w-full  px-3 mb-8">
          <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
            Link
          </label>
          <div class="ctl-edit-container">
            <input
              v-model="link"
              type="url"
              class="ctl-edit w-128"
              placeholder="Doodle......"
            >
          </div>
        </div>
        <div class="w-full md:w-1/3 px-3 mb-6 md:mb-0">
          <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
            Team
          </label>
          <div class="ctl-edit-container">
            <select
              id="grid-state"
              v-model="selectedTeam"
              placeholder="Teams"
              class="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker py-2 px-2 pr-4 rounded leading-tight focus:outline-none focus:bg-white focus:border-grey"
            >
              <option
                v-for="team in displayTeams"
                :key="team.teamId"
                :value="team.teamId"
              >
                {{ team.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap -mx-3 mb-6">
        <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
          <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
            Datum
          </label>
          <div class="ctl-edit-container">
            <sc-date-pick
              v-model="date"
              class="w-48"
              placeholder="Tag"
            />
          </div>
        </div>

        <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
          <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
            Zeit
          </label>
          <div class="ctl-edit-container">
            <sc-date-time-pick
              v-model="time"
              :input-style="'height:24px'"
              :minute-step="5"
              type="time"
              placeholder="Uhrzeit"
            />
          </div>
        </div>
      </div>
      <div class="flex flex-wrap -mx-3 mb-6">
        <div class="w-full px-3 mb-6 md:mb-0">
          <label
            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          >
            Ort
          </label>
          <div class="ctl-edit-container">
            Bei <input
              v-model="place"
              class="ctl-edit w-128"
              type="text"
              placeholder="place"
            >
          </div>
        </div>

        <div class="w-full mt-8">
          <label class="block text-grey-darker text-sm font-bold mb-1">Anmerkungen</label>

          <sc-html-editor
            v-model="description"
            placeholder="Anmerkungen zum Spieltag"
          />
        </div>
        <button
          class="save-button mt-4 w-64 hover:bg-primary-700 hover:border-primary-700"
          type="button"
          @click="createNewEvent()"
        >
          Speichern
        </button>
      </div>
    </form>
  </div>
</template>

<script>

import apiService from '../api/apiService'

export default {
    name: 'TeamEventCreate',
    data () {
        return {
            title: null,
            place: null,
            date: null,
            link: null,
            time: null,
            selectedTeam: null,
            displayTeams: null,
            description: ''
        }
    },
    async mounted () {
        await this.loadTeams()
    },
    methods: {

        async loadTeams () {
            let teams = await apiService.getMyTeams()

            if (teams && teams.status === 200) {
                teams = teams.data

                if (teams) {
                    this.displayTeams = teams
                    const storedTeam = localStorage.getItem('currentTeam')

                    if (storedTeam) {
                        this.selectedTeam = storedTeam
                    } else if (this.teams.length === 1) {
                        this.selectedTeam = this.teams[0].teamId
                    }
                }
            }
        },

        async createNewEvent () {
            const dateTime = this.date
            const time = new Date(this.time)
            dateTime.setHours(time.getHours())
            dateTime.setMinutes(time.getMinutes())
            dateTime.setSeconds(0)
            dateTime.setMilliseconds(0)
            await apiService.createTeamEvent(this.selectedTeam, this.title, dateTime, this.place, '', this.description, 0, this.link)
            this.$router.back()
        }
    }
}
</script>

<style scoped>

</style>